// assets.
import sortIcon from '../../assets/icons/filter-icon.svg';

type SortOrder = 'asc' | 'desc';

interface Props {
  order: SortOrder;
  onToggle: () => void;
}

export const SortDataFilter = ({ onToggle }: Props) => {
  return (
    <span
      onClick={onToggle}
      style={{
        alignItems: 'center',
        display: 'inline-flex',
        padding: '4px',
        cursor: 'pointer',
        gap: 4,
      }}
    >
      <img src={sortIcon} alt="Sort icon" />
    </span>
  );
};
